import { PureComponent } from 'react';

import { throttle } from 'throttle-debounce';

// "invisible" component that will call a callback after the window
// is resized.

export default class ResizeThrottler extends PureComponent {

    throttleFactory = (interval, callback) => {
        return throttle(interval, () => {
            clearTimeout(this.finalCall);
            callback();
            this.finalCall = setTimeout( () => {
                callback();
            }, interval * 2);
        });

    }

    componentDidMount() {

        // Use the throttler for most of it.
        // Add a special case for resizing to have one final call after
        // throttling because we need it due to CSS animation stuff.

        this.throttler = this.throttleFactory(this.props.interval, this.props.callback);
        window.addEventListener('resize', this.throttler);
    }

    componentDidUpdate() {

        // Reset the throttler if something changed
        this.throttler = this.throttleFactory(this.props.interval, this.props.callback);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.throttler);
    }

    render()
    {
        return null;
    }

}
